import React, { useEffect, useState } from 'react'
import { useQuote } from '../../Quote/QuoteContext';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '../../../Admin/Config/Config';
import { useLoginPopup } from '../../../Auth/LoginContext';
import { doc, getDoc } from 'firebase/firestore';

export default function PriceGenerator({ product, userDetails, priceOnly, quoteOnly }) {
  const { openQuote } = useQuote();
  const [uid, setUid] = useState(null);
  const { openPopup } = useLoginPopup();
  const [productUpdated, setProductUpdated] = useState(null);
  const [loading, setLoading] = useState(false);

  // ========================== Fetch Price =============================== //
  const fetchPrice = async (id) => {
    setLoading(true);
    let offer_price = 0;
    let original_price = 0;
    if (userDetails?.schemeId) {
      const priceRef = doc(
        db,
        "product_price",
        userDetails?.schemeId,
        "products",
        id
      );
      const priceSnap = await getDoc(priceRef);
      offer_price = priceSnap.exists() ? priceSnap.data().offer_price : 0;
      original_price = priceSnap.exists() ? priceSnap.data().original_price : 0;
      setProductUpdated({ offer_price, original_price, id: id });
      setLoading(false);
    } else { setLoading(false) }

    return { offer_price, original_price };
  };

  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        const uid = user.uid;
        await fetchPrice(product.id);
        setUid(uid);
      } else {
        setProductUpdated(null);
        setUid(null);
        setLoading(false);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product, auth]);

  const openQuotePopup = () => {
    if (!uid) {
      openPopup();
      return;
    }
    openQuote(product);
  };

  const offerPrice = productUpdated?.offer_price ?? product?.offer_price ?? 0;
  const originalPrice = productUpdated?.original_price ?? product?.original_price ?? 0;
  const hasPrice = offerPrice > 0;

  if (loading) {
    return (
      <div>
        <span>Loading...</span>
      </div>
    );
  }

  if (priceOnly) {
    if (!hasPrice) return null;
    return (
      <div className="text-right ml-auto">
        <p className="flex items-center justify-end gap-1 flex-wrap text-right ml-auto">
          {originalPrice > offerPrice && (
            <span className="text-red-500 text-xs sm:text-sm line-through font-normal">
              ${originalPrice.toFixed(2)}
            </span>
          )}
          <span className="text-green-600 font-bold text-sm sm:text-base md:text-lg">
            ${offerPrice.toFixed(2)}
          </span>
        </p>
      </div>
    );
  }

  if (quoteOnly) {
    if (hasPrice) return null;
    return (
      <div
        onClick={(e) => {
          e.stopPropagation();
          openQuotePopup();
        }}
        className="flex items-center justify-center gap-1 bg-white border border-red-600 hover:border-red-700 text-red-600 hover:text-red-700 font-medium cursor-pointer transition-colors duration-200 text-xs w-full py-2 px-3 rounded-lg mt-2.5 sm:mt-3"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-3 h-3"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
          />
        </svg>
        <span>Get Quote</span>
      </div>
    );
  }

  return (
    <div>
      {hasPrice ? (
        <div className="text-right ml-auto">
          <p className="flex items-center justify-end gap-1 flex-wrap text-right ml-auto">
            {originalPrice > offerPrice && (
              <span className="text-red-500 text-xs sm:text-sm line-through font-normal">
                ${originalPrice.toFixed(2)}
              </span>
            )}
            <span className="text-green-600 font-bold text-sm sm:text-base md:text-lg">
              ${offerPrice.toFixed(2)}
            </span>
          </p>
        </div>
      ) : (
        <div
          onClick={(e) => {
            e.stopPropagation();
            openQuotePopup();
          }}
          className="flex items-center justify-center gap-1 bg-white border border-red-600 hover:border-red-700 text-red-600 hover:text-red-700 font-medium cursor-pointer transition-colors duration-200 text-xs w-full py-2 px-3 rounded-lg"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
            />
          </svg>
          <span>Get Quote</span>
        </div>
      )}
    </div>
  );
}
